import * as React from "react";
import { Component } from "react";
import "./Modal.css";

interface IProps {
    onCloseClick: (evt: any) => void;
    className?: string;
    title?: string | JSX.Element;
    footer?: JSX.Element | null;
    theme?: string;
    loaderVisible?: boolean;
    isSecondModal?: boolean;
}

class Modal extends Component<IProps, any> {
    constructor(props) {
        super(props);
    }

    public render() {
        const {
            children,
            className = "",
        } = this.props;


        return (
            <div className={`fullpage ${className}`} onClick={this.OnFullClick}>
                <div onClick={this.OnModalClick} className={`modal`}>
                    <div className="modal__content">
                        <div className="modal__content--inner">
                            <div className="modal__main">{children}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private OnFullClick = (e) => {
        this.props.onCloseClick(e);
    }

    private OnModalClick = (e) => {
        e.stopPropagation();
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.tsx